var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


Curriculog.ProposalForm.FieldModel = (function ($, _, Backbone, FieldModel) {

    FieldModel = Curriculog.CurriculogModel.extend({
        defaults: {
            id: 0,
            type: '',
            value: '',
            systemRequired: '',
            required: false,
            validation: '',
            title: 'New Field',
            dataset: '',
            maxLength: 0,
            richText: false,
            conditional: false,
            displayText: 'New Field',
            showMarkup: 0,
            editList: [0]
        },

        // IMPORTANT!!! If ANY of a models validation is dynamically set/changed,
        // it must ALL be dynamically set on init
        // validation: {
        //     value: {}
        // },
        // labels: {},

        initialize: function(attrs, options) {
            Curriculog.CurriculogModel.prototype.initialize.apply(this, arguments);

            var maxLength = Number(attrs.maxLength);

            if (maxLength < 1) {
                maxLength = 16777215; // max length of MEDIUMTEXT
            }

            // Add a validation object to the model for Backbone.Validation to use.
            this.validation = {
                value: {
                    required: Boolean(attrs.required),
                    maxLength: maxLength,
                    pattern: String(attrs.validation) === 'date' ? 'none': String(attrs.validation),
                    fn: function(value, attr, computedState) {
                        // custom date validation
                        if (computedState.validation === 'date') {
                            var validationMsg = '{0} must be a valid date (mm/dd/yyyy or mm/dd/yyyy hh:mm:ss)'.replace('{0}', computedState.displayText);
                            var dateRegex = /^(((01|03|05|07|08|10|12)\/(0[1-9]|1[0-9]|2[0-9]|3[01]))|((04|06|09|11)\/(0[1-9]|1[0-9]|2[0-9]|30))|(02\/(0[1-9]|1[0-9]|2[0-9])))(\/\d{4})( (0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])?$/;
                            if (value.match(dateRegex)) {
                                var testDate = new Date(value);
                                if (testDate === NaN) {
                                    return validationMsg;
                                } else {
                                    // certain browsers will allow invalid dates to be created for certain months
                                    // (by carrying days over) so we need confirm the created date for testing
                                    // matches the actual field value
                                    var parsedDate = testDate.toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'});
                                    if (value.lastIndexOf(parsedDate) === -1) {
                                        return validationMsg;
                                    }
                                }
                            } else {
                                return validationMsg;
                            }
                        }
                    }
                }
            };

            // This is how Backbone.Validation knows what this fields name is.
            this.labels = {
                value: attrs.displayText
            };
        },

        /**
         * Used to get the display only value of a model. Primarily for title fields.
         *
         * @returns {string}
         */
        getDisplayValue: function() {
            return this.get('value');
        }
    });

    return FieldModel;

})($, _, Backbone, Curriculog.ProposalForm.FieldModel || {});
